<template>
  <div>
    <div class="container-block" style="margin: 15px 0">
      <a-form-model layout="inline">
        <a-form-model-item label="任务">
          <a-input style="width: 200px" placeholder="输入任务名称" @pressEnter="getList(search)" v-model="search.taskName" />
        </a-form-model-item>
        <a-form-model-item label="配方">
          <a-input style="width: 200px" placeholder="输入配方名称/代码" @pressEnter="getList(search)"
            v-model="search.formulaKeyword" />
        </a-form-model-item>
        <a-form-model-item label="动物类型">
          <animal-select style="width: 200px" @change="anmimlChange" :val="animal" />
        </a-form-model-item>
        <a-form-model-item label="推送日期">
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="search.taskDate" />
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click.enter="() => getList(search)">查询</a-button>
            <a-button @click="resetList">清空</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>

    <div class="container-block" style="padding-bottom: 0">
      <a-row style="margin-bottom: 15px">
        <a-space>
          <template v-for="el in buttonList">
            <template v-if="el.code.indexOf('third') < 0">
              <a-button :key="el.id" :type="el.code === 'add' ? 'primary' : el.code === 'delete' ? 'danger' : ''"
                :class="{ enable: !isDelete && el.code === 'show', forbidden: !isDelete && el.code === 'hide' }"
                :ghost="el.code === 'delete'"
                :disabled="(isDelete && (el.code === 'delete' || el.code === 'simulation' || el.code === 'show' || el.code === 'hide'))"
                @click="clickFunc(el.path, el.code)">
                {{ el.name }}
              </a-button>
            </template>
          </template>
          <template v-if="selectedRowKeys.length > 0">
            <a-tag> 已选择 {{ selectedRowKeys.length }} 项目 </a-tag>
          </template>
        </a-space>
      </a-row>
      <a-table :columns="columns" :loading="pushFormulaLoading" :data-source="list.records"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange, getCheckboxProps }"
        :row-key="(record) => record.id" :pagination="pagination" :scroll="{ x: 1300 }" @change="listChange">
        <template slot="formulaType" slot-scope="text, record">
          <span>{{ ['', '配合饲料', '混合日粮', 'TMR', '定制料'][record.formulaType] }}</span>
        </template>
        <template slot="formulaIsImport" slot-scope="text">
          <span>{{ text ? '是' : '否' }}</span>
        </template>
        <template slot="isProduct" slot-scope="text">
          <span>{{ text ? '是' : '否' }}</span>
        </template>
        <template slot="option" slot-scope="text, record">
          <a @click="viewDetail(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="importFomula(record)">导入配方</a>
          <a-divider type="vertical" />
          <a @click="generateProduct(record)" :disabled="record.isProduct == 1">生成产品</a>
        </template>
      </a-table>
    </div>

    <detail-drawer ref="detailDrawer" :hidden="detailVisible" :detailInfo="detailInfo" @close="toggleDetailVisible" />
  </div>
</template>

<script>
import { nhfMixins } from "../untils";
import AnimalSelect from "./select/AnimalSelect.vue";
import DetailDrawer from "./modal/DetailDrawer.vue";
const columns = [
  {
    title: "推送日期",
    dataIndex: "pushNhfTime",
    width: 140,
    ellipsis: true,
  },
  {
    title: "推送人",
    dataIndex: "pushUser",
    width: 80,
    ellipsis: true,
  },
  {
    title: "任务名称",
    dataIndex: "taskName",
    width: 100,
    ellipsis: true,
  },
  {
    title: "配方名称",
    dataIndex: "formulaName",
    width: 100,
    ellipsis: true,
  },
  {
    title: "配方代码",
    dataIndex: "formulaCode",
    width: 120,
    ellipsis: true,
  },
  {
    title: "配方类型",
    dataIndex: "formulaType",
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: "formulaType" },
  },
  {
    title: "动物类型",
    dataIndex: "animalTypeName",
    width: 80,
    ellipsis: true,
  },
  {
    title: "导入配方",
    dataIndex: "formulaIsImport",
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'formulaIsImport' },
  },
  {
    title: "生成产品",
    dataIndex: "isProduct",
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'isProduct' },
  },
  {
    title: "导入配方时间",
    align: "center",
    dataIndex: "formulaIsImportTime",
    sorter: (a, b) =>
      new Date(a.formulaIsImportTime).getTime() - new Date(b.formulaIsImportTime).getTime(),
    sortDirections: ["descend", "ascend"],
    width: 180,
    ellipsis: true,
  },
  {
    title: "生成产品时间",
    align: "center",
    dataIndex: "isProductTime",
    sorter: (a, b) =>
      new Date(a.isProductTime).getTime() - new Date(b.isProductTime).getTime(),
    sortDirections: ["descend", "ascend"],
    width: 180,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "option",
    width: 240,
    align: "center",
    fixed: "right",
    scopedSlots: { customRender: "option" },
  },
];
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    AnimalSelect,
    DetailDrawer
  },
  mixins: [nhfMixins],
  data() {
    return {
      setDistributionVisible: false,
      buttonList: [],
      btnLoading: false,
      btnId: '',
      selectItem: {},
      editorVisible: false,
      detailVisible: false,
      detailInfo: {
        formulaName: '',
        formulaCode: '',
        animal: '',
        formulaType: ''
      },
      copyVisible: false,
      columns,
      list: {},
      search: { status: 0 },
      filterData: {},
      animal: [],
      formulaId: null,
      copyId: null,
      pushFormulaLoading: false,
      versionLoading: false,
      version: [],
      sortModalVisible: false,
      sortData: {},
    };
  },
  mounted() {
    this.getList(this.search);
    this.getBtn(this.btnList);
  },
  watch: {
    $route() {
      this.getList(this.search);
    },
    btnList: {
      handler(val) {
        this.getBtn(val);
      },
      deep: true
    },
  },
  computed: {
    deleteDisable() {
      return this.selectedRowKeys.length === 0;
    },
    isDelete() {
      return this.selectedRowKeys.length === 0;
    },
  },
  methods: {
    getCheckboxProps(record) {
      return ({
        props: {
          disabled: (
            this.selectedRowKeys.length >= 50 &&
            !this.selectedRowKeys.includes(record.id)
          ) ||
            (
              record.isProduct == 1 ||
              record.formulaIsImport == 1
            )
        },
      });
    },
    typeClassName(t) {
      return this.classNames[t];
    },
    hideSortModal(type) {
      if (type) this.getList(this.search);
      this.sortModalVisible = false;
    },
    showSortModal() {
      this.sortModalVisible = true;
    },
    clickFunc(functionName, type) {
      this[functionName](type);
    },
    getBtn(val) {
      let formula = val.find(el => el.code === 'pushed-formula') || {};
      if (formula.children) {
        let simulation = formula.children.find(el => el.code === 'simulation');
        this.hasSimulationBtn = simulation ? true : false;
        this.buttonList = formula.children || [];
      }
    },

    toggleDetailVisible() {
      this.detailVisible = !this.detailVisible;
    },

    viewDetail(item) {
      this.detailInfo = item;
      this.$nextTick(() => {
        this.toggleDetailVisible();
      });
    },

    resetList() {
      this.search = { status: 0 };
      this.animal = [];
      this.getList(this.search);
    },

    listChange(page) {
      let { pageSize } = page || {};
      window.localStorage.setItem('pushedSize', pageSize);
      this.getList({ ...this.tablePageChange(page), ...this.filterData, ...this.search });
    },

    anmimlChange(val) {
      this.animal = val;
      this.search.animalTypeCode = [...val].pop();
    },

    getList(arg = {}) {
      let { current = 1, size = 20, taskDate } = arg || {};
      const data = {
        query: { current, size },
        formulaStaffId: window.localStorage.getItem('staffId'),
        ...arg,
      };
      if (taskDate) {
        data.pushTimeStart = taskDate[0] + ' 00:00:00';
        data.pushTimeEnd = taskDate[1] + ' 23:59:59';
        delete data.taskDate;
      }

      this.fetchPost({
        actions: this.pushedFormulaList,
        isList: true,
        data,
        name: "list",
        loading: "pushFormulaLoading",
        showMessage: false
      });
    },

    importFomula(record) {
      this.$confirm({
        icon: 'info-circle',
        title: "导入配方",
        content: "确定将多配方系统优化后的配方数据导入到配方模型中吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let res = await this.fetchPost({
            actions: this.importPushFormula,
            data: { formulaId: record.formulaId, id: record.id },
          });
          let { code } = res || {};
          if (code === 200) {
            this.getList(this.search);
          }
        }
      });
    },

    generateProduct(record) {
      this.$confirm({
        icon: 'info-circle',
        title: "生成产品",
        content: "确定将多配方系统优化后的配方数据直接生成产品吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let res = await this.fetchPost({
            actions: this.pushFormulaCreatePro,
            data: { formulaId: record.formulaId, id: record.id },
          });
          let { code } = res || {};
          if (code === 200) {
            this.getList(this.search);
          }
        }
      });
    },

    async deletePushedFormulas() {
      this.$confirm({
        title: "删除推送记录",
        content: "确定将选中的数据删除吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let res = await this.fetchPost({
            actions: this.delPushFormulaRecord,
            data: { idList: this.selectedRowKeys },
          });
          let { code } = res || {};
          if (code === 200) {
            this.cleanSelect();
            this.getList(this.search);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.disabled {
  color: #888;
}

.list-item {
  font-size: 12px;
}

.dropdown-list {
  max-height: 300px;
  width: 240px;
  overflow: auto;
  margin: -10px;
}

.enable {
  background: #02830f;
  color: #fff;
  border: none;

  &:hover {
    background: #14811f;
  }
}

.forbidden {
  background: #f59a23;
  color: #fff;
  border: none;

  &:hover {
    background: #f7ab47;
  }
}
</style>
<style lang="scss">
.ant-popover {
  z-index: 0;
}
</style>